import { types, Instance } from 'mobx-state-tree';


export const RoomStoreModel = types
  .model('RoomStore', {
    joinCode: types.maybeNull(types.string),
    roomId: types.maybeNull(types.string),
    participantId: types.maybeNull(types.string),
    isCreatingRoom: types.optional(types.boolean, false),
    isJoiningRoom: types.optional(types.boolean, false),
    joinError: types.maybeNull(types.string),
    creatingRoomMessage: types.optional(types.string, 'Creating...'),
  })
  .actions((self) => ({
    /**
     * Set room data after creating or joining a room
     */
    setRoomData(data: {
      joinCode: string;
      roomId: string;
      participantId: string;
    }) {
      self.joinCode = data.joinCode;
      self.roomId = data.roomId;
      self.participantId = data.participantId;
    },

    setCreatingRoom(isCreating: boolean) {
      self.isCreatingRoom = isCreating;
    },

    setJoiningRoom(isJoining: boolean) {
      self.isJoiningRoom = isJoining;
    },

    setCreatingRoomMessage(message: string) {
      self.creatingRoomMessage = message;
    },

    setJoinError(error: string | null) {
      self.joinError = error;
    },

    clearJoinError() {
      self.joinError = null;
    },

    clearRoom() {
      self.joinCode = null;
      self.roomId = null;
      self.participantId = null;
      self.isCreatingRoom = false;
      self.isJoiningRoom = false;
      self.joinError = null;
      self.creatingRoomMessage = 'Creating...';
    },
  }));

export interface RoomStore extends Instance<typeof RoomStoreModel> {}

/**
 * Singleton instance of RoomStore
 */
export const roomStore = RoomStoreModel.create({
  joinCode: null,
  roomId: null,
  participantId: null,
  isCreatingRoom: false,
  isJoiningRoom: false,
  joinError: null,
  creatingRoomMessage: 'Creating...',
});
